import { render } from "./componentEditSpc.vue?vue&type=template&id=e8bdca54"
import script from "./componentEditSpc.vue?vue&type=script&lang=js"
export * from "./componentEditSpc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__